<template>
  <div>
    <div class="container-fluid" id="nav-bar">
      <b-navbar toggleable="lg">
        <b-collapse id="nav-collapse" is-nav>
          <nav-link></nav-link>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>
<script>
import NavLink from "@/components/header/NavLink.vue";
export default {
  components: {
    NavLink,
  },
};
</script>
